var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivationVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio-ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M30.4215 5.48586C32.1186 5.48586 33.4948 6.86203 33.4948 8.5591V39.44C33.4948 41.137 32.1186 42.5132 30.4215 42.5132C28.7246 42.5131 27.3493 41.137 27.3493 39.44V8.5591C27.3493 6.8621 28.7246 5.48599 30.4215 5.48586ZM19.6667 13.148C21.3637 13.148 22.7389 14.5242 22.7389 16.2212V31.7808C22.7389 33.4778 21.3637 34.854 19.6667 34.854C17.9696 34.854 16.5934 33.4779 16.5934 31.7808V16.2212C16.5934 14.5241 17.9696 13.148 19.6667 13.148ZM41.1686 13.148C42.8655 13.1482 44.2409 14.5243 44.2409 16.2212V31.7808C44.2409 33.4777 42.8655 34.8538 41.1686 34.854C39.4715 34.854 38.0954 33.4779 38.0954 31.7808V16.2212C38.0954 14.5241 39.4715 13.148 41.1686 13.148ZM8.91178 18.2544C10.6087 18.2546 11.984 19.6307 11.984 21.3277V27.9497C11.984 29.6467 10.6087 31.0227 8.91178 31.023C7.21471 31.023 5.83854 29.6468 5.83854 27.9497V21.3277C5.83854 19.6306 7.21471 18.2544 8.91178 18.2544ZM51.9323 16.8794C53.6293 16.8795 55.0046 18.2556 55.0046 19.9527V26.5747C55.0045 28.2717 53.6293 29.6469 51.9323 29.647C50.2353 29.647 48.8591 28.2717 48.859 26.5747V19.9527C48.859 18.2556 50.2352 16.8794 51.9323 16.8794Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationVoice);
export default __webpack_public_path__ + "static/media/activation-voice.3e5ee7005117870769c2b69236a5925c.svg";
export { ForwardRef as ReactComponent };